import { config } from '@config'
import { HttpService } from '@services/HttpService'
import { storage } from '@services/storageService'
import axios from 'axios'

export class ProductPriceService {
  httpService = new HttpService()
  getProductPrices = async (buyingSessionGroupId, priceGroup, priceType) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}price/buyingSessionGroup/${buyingSessionGroupId}/priceGroup/${priceGroup}/priceType/${priceType}`
      const accessToken: string = storage.getItem('access_token')

      const response: any = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      return response?.data
    } catch (e) {
      console.log(e)
    }
  }
}
